
import { mapActions, mapState, mapGetters } from "vuex";
import dialogCloseBtn from "../common/dialog-close-btn.vue";

export default {
  components: { dialogCloseBtn },
  data() {
    return {
      selectedPrinters: "",
      loading: false
    };
  },
  props: {
    dialog: false
  },
  mounted() {
    this.selectedPrinters = this.printers
      .filter((el) => el.is_master_printer)
      .map((el) => el.id);
  },
  computed: {
    ...mapState("restaurant", ["printers"])
  },
  watch: {},
  methods: {
    ...mapActions("restaurant", ["updatePrinter", "getLocationDetails"]),

    async handleModifyMasterKotPrinter() {
      const $this = this;
      this.loading = true;
      try {
        this.printers.forEach(async (element) => {
          if (
            element.is_master_printer &&
            !this.selectedPrinters.includes(element.id)
          ) {
            await this.updatePrinter({
              printer: element.id,
              payload: {
                printer: { is_master_printer: false }
              }
            });
          } else if (
            !element.is_master_printer &&
            this.selectedPrinters.includes(element.id)
          ) {
            await this.updatePrinter({
              printer: element.id,
              payload: {
                printer: { is_master_printer: true }
              }
            });
          }
        });
        await this.getLocationDetails();
        this.$nuxt.$emit("show-toast", {
          text: "Printer modified successfully",
          color: "success darken-2",
          icon: "done",
          flat: true
        });
        this.$emit("close-dialog");
      } catch (err) {
        this.$nuxt.$emit("show-error-toast", err);
      }
      this.loading = false;
    }
  }
};
